let t="https://static.fitpetcdn.com",e={production:`${t}/web/prod`,development:`${t}/web/staging`};export{t as FITPET_CDN_URL,e as S3_PATH};
